import {
  Avatar,
  Box,
  Button,
  Flex,
  Input,
  Text,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  Stack,
  useColorMode,
  Heading,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Image
} from '@chakra-ui/react'
import React, { useContext }  from 'react'
import { FiSearch } from "react-icons/fi";
import { AiOutlineDown } from "react-icons/ai";
import { AiOutlineMenu } from "react-icons/ai";
import Sidebar from './Layout/Sidebar';
import ralco_logo from './ralco_logo.png'
import { Link, useNavigate } from 'react-router-dom'
import { Context } from './store';

const Header = () => {
  const { colorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure()
  const navigate = useNavigate()
  const bgColor = { light: "blue.500", dark: "blue.900" };
  // const userData = JSON.parse(localStorage.getItem('user'))
  const { userData } = useContext(Context)

  const sideBarData = [
    // ORDER MANAGEMENT
    {
      Orders: [
        { title: "All Order", url: "/orders/all" },
        // { title: "Search Order Item", url: "/orders/search-orderItem-tags" },
        { title: "Draft Order", url: "/orders/draft" },
        { title: "Published Order", url: "/orders/published" },
        { title: "Order Created", url: "/orders/created" },
        {
          title: "Awaiting Verification",
          url: "/orders/awaiting-verification",
        },
        { title: "Verified Orders", url: "/orders/verified" },
        // { title: "Out for Delivery", url: "/orders/out-for-delivery" },
        { title: "Delivered Orders", url: "/orders/delivered" },
        // { title: "Fulfilled Orders", url: "/orders/fulfilled" },
        // { title: "Return Order", url: "/orders/return-order" },
        { title: "Canceled Orders", url: "/orders/canceled" },
        {title: 'Payment Pending', url: '/orders/payment-pending'},
        {title: 'Terminated', url: '/orders/terminated'}, 
        {title: 'Early Closure', url: '/orders/early-closure'}, 
        {title: 'Active', url: '/orders/active'}, 
        {title: 'Cancelled', url: '/orders/cancelled'}, 
        {title: 'Ending Tommorrow', url: '/orders/ending-tomorrow'}, 
        {title: 'Ended', url: '/orders/ended'}, 
      ],
      icon: `<BiCube fontSize={'26px'}/>`,
      id: "ORDER_MANAGEMENT",
    },
    // TENURE MANAGEMENT
    {
      Tenures: [
        { title: "All Tenure", url: "/tenures/all" },
        { title: "Tenure Issued", url: "/tenures/invoice/issued" },
        { title: "Tenure Decline", url: "/tenures/invoice/decline" },
        { title: "Tenure Defaulted", url: "/tenures/invoice/defaulted" },
        {
          title: "Tenure Defaulted Cut Off",
          url: "/tenures/invoice/defaulted-cut-off",
        },
        {
          title: "Tenure Defaulted Due",
          url: "/tenures/invoice/defaulted-due",
        },
        { title: "Tenrue Failed", url: "/tenures/invoice/failed" },
        { title: "Tenrue Paid", url: "/tenures/invoice/paid" },
        { title: "Tenure Pending", url: "/tenures/invoice/pending" },
      ],
      icon: `<RxLapTimer fontSize={'26px'}/>`,
      id: "TENURE_MANAGEMENT",
    },

    // RETURN MANAGEMENT
    {'Returns': [
      {title: 'All Return', url: '/returns/all'},
      {title:"Return Approved", url:"/returns/approved"},
      {title:"Return Generated", url:"/returns/generated"},
      {title:"Return Completed", url:"/returns/completed"},
      {title:"Return Order Picked", url:"/returns/order-picked"},
      {title:"Received at Warehouse", url:"/returns/received-at-warehouse"},
      {title:"QC Completed", url:"/returns/qc-completed"},
      {title:"Settlement Calculated", url:"/returns/settlement-calculated"},
      {title:"Return Request Closed", url:"/returns/closed-requests"},
    ],
    'icon': `<TbTruckReturn fontSize={'26px'}/>`,
    'id': 'RETURNS_MANAGEMENT'},
    // DISPUTE MANAGEMENT
    {
      Disputes: [{ title: "All Dispute", url: "/dispute/all" }],
      icon: `<IoMdChatbubbles fontSize={'26px'}/>`,
      id: "DISPUTE_MANAGEMENT",
    },
    // SETTLEMENT MANAGEMENT
    {
      Settlements: [{ title: "All Settlement", url: "/settlements/all" }],
      icon: `<BsFileEarmarkCheckFill fontSize={'26px'}/>`,
      id: "SETTLEMENT_MANAGEMENT",
    },
    // DELIVERY BOY
    // {
    //   "Order Delivery": [
    //     { title: "All Deliveries", url: "/order-delivery/all" },
    //     { title: "Out of Delivery", url: "/order-delivery/out-for-delivery" },
    //     { title: "Delivered", url: "/order-delivery/delivered" },
    //   ],
    //   icon: `<TbTruckDelivery fontSize={'26px'}/>`,
    //   id: "DELIVERY_MANAGEMENT",
    // },
    // DELIVERY BOY
    {
      "Return Pick up": [
        { title: "All Returns", url: "/order-return/all" },
        { title: "Picked up Orders", url: "/order-return/order-picked-up" },
        {
          title: "Delivered to Warehouse",
          url: "/order-return/delivere-to-warehouse",
        },
      ],
      icon: `<TbTruckReturn fontSize={'26px'}/>`,
      id: "DELIVERY_MANAGEMENT",
    },
    // CUSTOMER VERIFICATION
    {
      "Customer Verification": [
        { title: "All Verifications", url: "/verification/all" },
        { title: "Verification Pending", url: "/verification/pending" },
        { title: "Customer Verified", url: "/verification/customer-verified" },
        { title: "Unverified", url: "/verification/un-verified" },
        { title: "Credit Report", url: "/verification/credit-report" },
      ],
      icon: `<BsFillPersonCheckFill fontSize={'26px'}/>`,
      id: "CUSTOMER_MANAGEMENT",
    },
    // USER MANAGEMENT
    {
      "User Access": [{ url: "/user-access" }],
      icon: `<BsFillPeopleFill fontSize={'26px'}/>`,
      id: "USER_MANAGEMENT",
    },
    // NOTIFICATIONS
    {
      Notifications: [{ url: "/notifications/all" }],
      icon: `<IoIosNotifications fontSize={'26px'}/>`,
      id: "NOTIFICATION_MANAGEMENT",
    },
    // SETTINGs
    {
      Settings: [{ url: "/settings" }],
      icon: `<IoMdSettings fontSize={'26px'}/>`,
      id: "SETTINGS_MANAGEMENT",
    },
  ];

  return (
    <Box position={'sticky'} top={'0px'} zIndex={'999'}>
      <Flex w={'100%'} justifyContent={'space-between'}>
        <Flex justifyContent={'flex-start'} bg={bgColor[colorMode]} w="20%" p={2} display={{ base: 'none', md: 'none', lg: 'flex', xl: 'flex', '2xl': 'flex' }}> 
          <Flex w={'70%'} alignItems={'center'}  ml={3}>
          <Link to={'/'}>
          <Image
          boxSize='35px'
          objectFit='fit'
          src={ralco_logo}
          alt='logo'
          mt={1}
        />
        </Link>
         
         <Heading textAlign={"center"} color={'white'} fontWeight={'bold'} fontSize={'28px'} letterSpacing={'1px'} ml={3}>EQUIPP</Heading>
          
          </Flex>
        </Flex>

        {/* menu bar disclosure for responsive */}
        <Flex justifyContent={'center'} alignItems={'center'} fontSize={'26px'} bg={bgColor[colorMode]} w="20%" p={2} display={{ base: 'flex', md: 'flex', lg: 'none', xl: 'none', '2xl': 'none' }}>
        <AiOutlineMenu color='white' onClick={onOpen} cursor={'pointer'} >
        Open
        </AiOutlineMenu>
        </Flex>
      <Drawer
        isOpen={isOpen}
        placement='left'
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton mt={'9px'} color={'white'}/>
          <DrawerHeader bgColor={bgColor[colorMode]}>      
           <Text color={'white'} fontSize={'24px'} ml={'5px'}>EQUIPP</Text> 
            </DrawerHeader>
          <DrawerBody px={0} py={1}>
            <Sidebar isBase={true} onClose={onClose} data={sideBarData}/>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

        <Box w={{base: '80%', md: '80%', lg: '79.8%', xl: '79.8%', '2xl': '79.8%'}}  bg={bgColor[colorMode]} p={2}>
          <Flex justifyContent={'space-between'} alignItems={'center'} pl={{base: 1, md: 1, lg: 2, xl: 4, '2xl': 4}} py={{base: 0, md: 0, lg: 1, xl: 1, '2xl': 1}}>
            <Box >
              {/* <InputGroup>
                <InputLeftElement
                  pointerEvents="none"
                  children={<FiSearch />}
                  size="xs"
                  mt={-1}
                />
                <Input
                  placeholder='Search by name, order id'
                  bgColor={'white'}
                  rounded={'full'}
                  size={'sm'} />
              </InputGroup> */}
            </Box>
            <Box width={{base: '25%', md: '25%', lg: '25%', xl: '25%', '2xl': '15%' }} >
              <Stack direction='row'  >

                <Menu>
                  <MenuButton
                    px={4}
                    color={'white'}
                    as={Button}
                    colorScheme='blue.500'
                    w={'100%'}
                  >
                  <Flex justifyContent={'space-evenly'} alignItems={'center'} mr={{base: 0, md: 10, lg: 10, xl: 6, '2xl': 6 }}>
                    <Avatar size={{base: 'sm', md: 'md', lg: 'md', xl: 'md', '2xl': 'md' }} name={(userData?.firstName || 'unknown')  + " " +  (userData?.lastName || 'unknown')} src='#' mr={2}/>
                    <Text  display={{ base: 'none', md: 'block', lg: 'block', xl: 'block', '2xl': 'block' }} mr={2}>{(userData?.firstName || 'unknown')  + " " +  (userData?.lastName || 'unknown')}</Text>
                    <Box display={{ base: 'none', md: 'block', lg: 'block', xl: 'block', '2xl': 'block' }} mt={'3px'}>
                      <AiOutlineDown/>
                    </Box>       
                  </Flex>
                  </MenuButton>
                  <MenuList>
                    <MenuGroup title='Profile'>
                      {/* <MenuItem>My Account</MenuItem> */}
                      {/* <MenuItem>Payments </MenuItem> */}
                      <MenuItem onClick={() => {
                        // localStorage.removeItem('user')
                        localStorage.removeItem('token')
                        sessionStorage.clear()
                        navigate('/')
                      }}>Logout</MenuItem>
                    </MenuGroup>
                    {/* <MenuDivider /> */}
                    {/* <MenuGroup title='Help'>
                      <MenuItem>Docs</MenuItem>
                      <MenuItem>FAQ</MenuItem>
                    </MenuGroup> */}
                  </MenuList>
                </Menu>
              </Stack>
            </Box>
          </Flex>
        </Box>
      </Flex>
    </Box>
  )
}

export default Header
